import React from "react";
import dynamic from "next/dynamic";
import Cta from "./cta/cta";

import Banner from "./banner/banner";
import LogosSlider from "../common/LogosSlider";
import NextProject from "./next-project/nextProject";

const Explore = dynamic(() => import("./explore-section/explore"));
const CaseStudies = dynamic(() => import("./case-studies/case-studies"));
const Process = dynamic(() => import("./process-section/process"));
const Developer = dynamic(() => import("./developer-section/developer"));
const Faq = dynamic(() => import("../home-new/faq/faq"));
const Feature = dynamic(() => import("../home-new/feature/feature"));
const Customer = dynamic(() => import("../home-new/customer-section/customer"));
const Contact = dynamic(() => import("./contact-section/contact"));
const ServicesForIndustries = dynamic(() => import('../service-details-new/services-for-industries/services-for-industries'))

const TechnologyNew = (props) => {
	const { blocks } = props;


	return (
		<>
			<div className="nome-new tech-pad bg-one ">
				{blocks?.length > 0 &&
					blocks.map((block, i) => {
						return (
							<React.Fragment key={i}>
								{block.__component ===
									"blocks.home-new-banner" && (
										<>
											<Banner data={block} />
											{/* <Slider /> */}
											<LogosSlider />
										</>
									)}
								{block.__component ===
									"blocks.strategies" && (
										<NextProject data={block} />
									)}
								{block.__component ===
									"blocks.technical-prowess" && (
										<Explore data={block} />
									)}
								{block.__component ===
									"blocks.contact-us-case-study" && (
										<CaseStudies data={block} />
									)}
								{
									block.__component === "blocks.services-for-industries" &&
									<ServicesForIndustries data={block} />
								}
								{block.__component ===
									"blocks.home-new-development-process" && (
										<Process data={block} />
									)}
								{block.__component ===
									"blocks.hiring-modal" && (
										<Developer data={block} />
									)}
								{block.__component ===
									"blocks.tech-service-cta" && (
										<Cta data={block} />
									)}
								{block.__component ===
									"blocks.faq" && (
										<Faq data={block} />
									)}
								{block.__component ===
									"blocks.top-stories" && (
										<Feature data={block} />
									)}
								{block.__component ===
									"blocks.testimonials" && (
										<Customer data={block} />
									)}
								{block.__component ===
									"blocks.home-new-form" && (
										<Contact data={block} />
									)}

							</React.Fragment>
						);
					})}
			</div>
		</>
	);
};

export default TechnologyNew;

